import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import mainImg from "../Img/fin-home-img.png";
// import AboutMainSection from "./AboutMainSection";
import CallToAction from "./CallToAction";
import FaqLoansSmco from "./FAQ";
import LoanSteps from "./Loansteps";
import WhyChooseUs from "./WhyChooseUs";
import Associates from "./Associates";
import WhoWeAre from "./WhoWeAre";
import LoanOfferings from "./LoanOfferings";
import MumbaiAdvantage from "./MumbaiAdvantage";
import ClientSuccessStories from "./ClientSuccessStories";
import HowToGetStarted from "./HowToGetStarted";
import MakePartner from "./MakePartner";

const scrollReveal = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

const staggerContainer = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.4 } },
};

const Home = () => {
    const navigate = useNavigate();
    const loanData = [
        {
            title: "Home Loan - Your Dream Home Awaits",
            description: "Secure a home loan with competitive rates and expert guidance. Whether buying a new home or refinancing, we make the process simple and stress-free.",
            icon: "fa-home",
            link: "/home-loan-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Commercial Loan - Boost Your Business",
            description: "Flexible commercial financing solutions for businesses. Access funds for operations, expansion, and investments with low-interest rates and quick approvals.",
            icon: "fa-building",
            link: "/commercial-loan-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Mortgage Loan - Smart Financing for Homeowners",
            description: "Flexible mortgage solutions designed for homeowners. Benefit from low-interest rates, easy approvals, and expert assistance tailored to your needs.",
            icon: "fa-hand-holding-dollar",
            link: "/mortgage-loan-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Business Loan - Fuel Your Growth",
            description: "Empower your business with tailored financing solutions. Access working capital, expansion funds, and equipment financing with expert support.",
            icon: "fa-briefcase",
            link: "/business-loan-mumbai-thane-palghar-maharashtra-delhi-india",
        },
    ];

    return (
        <>
            <motion.div className="landing-section-smco" variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{ once: true }}>
                <motion.div className="landing-container-smco landing-container-smco1" variants={scrollReveal}>
                    <motion.h1 variants={scrollReveal}>Welcome to Magnify Advisory <span className="animate__animated animate__jackInTheBox animate__delay-1s"></span></motion.h1>
                    <motion.p variants={scrollReveal}>Your trusted partner for home loans, Commercial Loan, mortgage loans, and business loans
across the Mumbai Metropolitan Region</motion.p>
                    <button className="landing-container-cta-smco" variants={scrollReveal} onClick={() => navigate("/apply-loan-online")}>Apply Now</button>
                </motion.div>
                <motion.div className="landing-container-smco landing-container-smco2 animate__animated animate__zoomInDown animate__delay-1s" variants={scrollReveal}>
                    <motion.img src={mainImg} alt="" variants={scrollReveal} />
                </motion.div>
            </motion.div>
            <motion.div variants={scrollReveal}><Associates /></motion.div>

            <motion.div variants={scrollReveal}><WhoWeAre /></motion.div>
            <motion.div variants={scrollReveal}><LoanOfferings /></motion.div>

            <motion.div className="loan-card-main" variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{ once: true }}>
                <motion.h2 className="sections-title-smco" variants={scrollReveal}>
                    <span className="horizontal-line"></span>Our Core Services
                </motion.h2>
                <motion.p className="sections-description-smco" variants={scrollReveal}>
                    Quick approvals, low rates, and hassle-free loans tailored for you.
                </motion.p>

                <motion.div className="loan-cards-container-smco" variants={staggerContainer}>
                    {loanData.map((loan, index) => (
                        <motion.div key={index} className="loan-card-smco" variants={scrollReveal}>
                            <motion.div className="loan-card-container-icon-dashed-border" variants={scrollReveal}>
                                <motion.div className="loan-card-icon-container-smco" variants={scrollReveal}>
                                    <motion.i className={`fa-solid ${loan.icon} loan-card-icon-smco`} variants={scrollReveal}></motion.i>
                                </motion.div>
                            </motion.div>
                            <motion.h3 className="loan-card-title-smco" variants={scrollReveal}>{loan.title}</motion.h3>
                            <motion.p className="loan-card-description-smco" variants={scrollReveal}>{loan.description}</motion.p>
                            <motion.button
                                className="loan-card-button-smco"
                                variants={scrollReveal}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    navigate(loan.link);
                                }}
                            >
                                Learn More
                            </motion.button>
                        </motion.div>
                    ))}
                </motion.div>

                <div
                    onClick={() => navigate("/loan-services-india")}
                    style={{ marginTop: "40px" }}
                    className="loan-card-button-smco">
                    View all services
                </div>
            </motion.div>

            <motion.div variants={scrollReveal}><WhyChooseUs /></motion.div>
            <motion.div variants={scrollReveal}><ClientSuccessStories /></motion.div>
            <motion.div variants={scrollReveal}><HowToGetStarted /></motion.div>
            <motion.div variants={scrollReveal}><MakePartner /></motion.div>
            <motion.div variants={scrollReveal}><MumbaiAdvantage /></motion.div>
            {/* <motion.div variants={scrollReveal}><AboutMainSection /></motion.div> */}
            <motion.div variants={scrollReveal}><LoanSteps /></motion.div>
            <motion.div variants={scrollReveal}><CallToAction /></motion.div>

            

            <motion.div variants={scrollReveal}><FaqLoansSmco /></motion.div>
        </>
    );
};

export default Home;